import { render, staticRenderFns } from "./EmploymentView.vue?vue&type=template&id=56e3fa49&"
import script from "./EmploymentView.vue?vue&type=script&lang=ts&"
export * from "./EmploymentView.vue?vue&type=script&lang=ts&"
import style0 from "./EmploymentView.vue?vue&type=style&index=0&id=56e3fa49&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports